
// 权限管理
import fetch from '../fetch';

import {
  // 菜单管理
  AUTH_MENUS_LIST,
  AUTH_MENUS_ADD,
  AUTH_MENUS_EDIT,
  AUTH_MENUS_DELETE,
  // 字典数据
  AUTH_DICTS_LIST,
  AUTH_DICTS_SET_AUTH,
  AUTH_DICTS_SET_ENABLE,
  // 账号管理
  AUTH_GET_USER_LIST,
  AUTH_USER_ADD_NEW,
  AUTH_USER_EDIT_NEW,
  AUTH_NEW_ROLE_GET_APP_LIST,
  // 角色管理
  AUTH_TEAM_NEW_LIST,
  AUTH_TEAM_ADD_NEW,
  AUTH_TEAM_EDIT_NEW,
  AUTH_ADD_EFFECTIVE_TIME,
  AUTH_NEW_ROLE_TEAM_USER_LIST,
  AUTH_NEW_ROLE_ADD_ACCOUNT_BATCH,
  AUTH_DEPT_GET_CAN_SELECT_ORG_DEPT,
  AUTH_DEPT_GET_SING_ORG_DEPT,
  AUTH_GET_TEAM_DEPT_BY_TEAM_ID,
  AUTH_GET_TEAM_VALUE_BY_TEAM_ID,
  AUTH_GET_MENU_LIST_BY_TEAM_ID,
  AUTH_GET_ORGLIST_BY_TEAM_ID,
  // 独立应用
  AUTH_GET_MENUS_GET_APP_LIST,
} from '../url';

/**
 * 查询菜单列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAuthMenuList(data) {
  return fetch({
    url: AUTH_MENUS_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 新增菜单或新增菜单子项 和 编辑菜单
 * @param  {Object} data  表单
 * @param  {Object} type  操作类型
 * @return {Promise}      返回请求的Promise
 */
function authMenuAdd(data, type) {
  let url;
  if (type === 'edit') {
    url = AUTH_MENUS_EDIT;
  } else {
    url = AUTH_MENUS_ADD;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 删除菜单
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authMenuDelete(data) {
  return fetch({
    url: AUTH_MENUS_DELETE,
    method: 'get',
    params: data
  });
};

/**
 * 查询字典项 列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAuthDictsList(data) {
  return fetch({
    url: AUTH_DICTS_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 添加字典项到权限控制
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authDictsSetAuth(data) {
  return fetch({
    url: AUTH_DICTS_SET_AUTH,
    method: 'post',
    data: data
  });
};

/**
 * 对字典项进行启用和禁用
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authDictsSetEnable(data) {
  return fetch({
    url: AUTH_DICTS_SET_ENABLE,
    method: 'post',
    data: data
  });
};

/**
 * 区分系统账号和应用账号 列表
 * @param  {String} type  查询系统账号的时候是/getUserList?type=sys，查询应用系统的时候是/getUserList?type=app
 * @return {Promise}      返回请求的Promise
 */
function getAuthUserList(data, type) {
  return fetch({
    url: AUTH_GET_USER_LIST + '?type=' + type,
    method: 'post',
    data: data
  });
};

/**
 * 新增/编辑账号接口修改
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authUserAddNew(data, id) {
  // 新增
  let url = AUTH_USER_ADD_NEW;
  if (id) {
    // 编辑
    url = AUTH_USER_EDIT_NEW;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data
  });
};

/**
 * 应用系统列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function authGetAppList(data) {
  return fetch({
    url: AUTH_NEW_ROLE_GET_APP_LIST,
    method: 'get',
    params: data
  });
};

/**
 * 查询角色列表接口修改
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTeamNewList(data) {
  return fetch({
    url: AUTH_TEAM_NEW_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 新增/编辑角色接口
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function teamAddNew(data, id) {
  // 新增
  let url = AUTH_TEAM_ADD_NEW;
  if (id) {
    // 编辑
    url = AUTH_TEAM_EDIT_NEW;
  }
  return fetch({
    url: url,
    method: 'post',
    data: data,
    // 是否需要自定义品牌
    brandInit: true
  });
};

/**
 * 角色用户延期
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function addEffectiveTime(data) {
  return fetch({
    url: AUTH_ADD_EFFECTIVE_TIME,
    method: 'post',
    data: data
  });
};

/**
 * 获取角色关联的用户列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function newRoleTeamUserList(data) {
  return fetch({
    url: AUTH_NEW_ROLE_TEAM_USER_LIST,
    method: 'post',
    data: data
  });
};

/**
 * 角色用户 新增用户
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function newRouteAddAccountBatch(data) {
  return fetch({
    url: AUTH_NEW_ROLE_ADD_ACCOUNT_BATCH,
    method: 'post',
    data: data
  });
};

/**
 * 组织部门下拉框内容
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCanSelectOrgDept(data) {
  return fetch({
    url: AUTH_DEPT_GET_CAN_SELECT_ORG_DEPT,
    method: 'get',
    params: data
  });
};

/**
 * 组织部门下拉框点击父部门的时候只获取下一层的部门
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSingOrgDept(data) {
  return fetch({
    url: AUTH_DEPT_GET_SING_ORG_DEPT,
    method: 'get',
    params: data
  });
};

/**
 * 查询角色下面的组织部门
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTeamDeptByTeamId(data) {
  return fetch({
    url: AUTH_GET_TEAM_DEPT_BY_TEAM_ID,
    method: 'get',
    params: data
  });
};

/**
 * 查询角色下面的字典数据
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTeamValueByTeamId(data) {
  return fetch({
    url: AUTH_GET_TEAM_VALUE_BY_TEAM_ID,
    method: 'get',
    params: data
  });
};

/**
 * 查询角色下面的权限菜单和按钮
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getMenuListByTeamId(data) {
  return fetch({
    url: AUTH_GET_MENU_LIST_BY_TEAM_ID,
    method: 'get',
    params: data
  });
};

/**
 * 获取角色下面的所有主体
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getOrgList(data) {
  return fetch({
    url: AUTH_GET_ORGLIST_BY_TEAM_ID,
    method: 'get',
    params: data,
    isNoMsg: true
  });
};

/**
 * 获取独立应用菜单列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAppList(data) {
  return fetch({
    url: AUTH_GET_MENUS_GET_APP_LIST,
    method: 'get',
    params: data
  });
};

const authority = {
  // 菜单管理
  getAuthMenuList,
  authMenuAdd,
  authMenuDelete,
  // 字典数据
  getAuthDictsList,
  authDictsSetAuth,
  authDictsSetEnable,
  // 账号管理
  getAuthUserList,
  authUserAddNew,
  authGetAppList,
  // 角色管理
  getTeamNewList,
  teamAddNew,
  addEffectiveTime,
  newRoleTeamUserList,
  newRouteAddAccountBatch,
  getCanSelectOrgDept,
  getSingOrgDept,
  getTeamDeptByTeamId,
  getTeamValueByTeamId,
  getMenuListByTeamId,
  getOrgList,
  // 独立应用
  getAppList,
};

export { authority };
